import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {RouteData} from "../shared/services/route-data/route-data";
import {RouteDataService} from "../shared/services/route-data/route-data.service";
import {
  UserSubscription,
  UserSubscriptionType,
  UserSubscriptionIds,
  UserSubscriptionCategory
} from "../user/user-subscription";
import {Config} from "../config/config";
import {filter, switchMap, takeUntil} from "rxjs/operators";
import {Store} from "@ngrx/store";
import {Website} from "../websites/website/website";
import * as fromStore from '../store';
import {combineLatest} from "rxjs";
import {clientRoles} from "../user/user-roles-actions";
import {Subject} from "rxjs";
import {User} from "../user/user";
import {Utils} from "../shared/utils/utils";
import {GoogleAnalyticsService} from "../shared/services/google-analytics/google-analytics.service";
import {DbModalService} from "../modules/modal/modal";


@Component({
    selector: 'db-workspace',
    templateUrl: './workspace.component.html',
    styleUrls: ['./workspace.component.scss'],
    standalone: false
})
export class WorkspaceComponent implements OnInit, OnDestroy, AfterViewInit {

  public routeData: RouteData;
  public Config = Config;
  public workspaceTab: any;
  public currentSubscription: UserSubscription;
  public user: User;
  public UserSubscriptionType: any = UserSubscriptionType;
  public aiStarterAnnual: UserSubscription;
  public websiteCopied: boolean = false;
  public UserSubscriptionIds: any = UserSubscriptionIds;
  public currentWorkspaceRole: number;
  public workspaceRoles = clientRoles;

  public isScrolled: boolean;
  public position: number = 50;
  public scrolled: number = 50;
  public isMobile: boolean = false;
  public demoUser: boolean = false;
  public annualPrice: number;
  public UserSubscriptionCategory = UserSubscriptionCategory;
  private scrollableElement: Element;
  private offsetElement: Element;
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private router: Router,
    private _route: ActivatedRoute,
    // private _malihuScrollbarService: MalihuScrollbarService,
    private _store: Store<fromStore.DbStoreState>,
    private _routeDataService: RouteDataService,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _modalService: DbModalService,
  ) {}

  ngOnInit(): void {
    this.routeData = this._routeDataService.getCurrentRouteData();
    this.currentSubscription = this._route.snapshot.data['userSubscription'];
    this.user = this._route.snapshot.data['user'];

    this.demoUser = Utils.isDemoUser(this.currentSubscription, this.user);
    this.workspaceTab = this._route.snapshot.params['tabId'];
    if (!['workspace-settings', 'billing-details', 'subscription-plan', 'payment-methods', 'invoices'].includes(this.workspaceTab)) {
      this.router.navigate(['/404'], {skipLocationChange: true, replaceUrl: true});
    }
    this.addEventHandlers();
    this.isMobile = window.innerWidth <= 991;
  }

  ngAfterViewInit(): void {
    this.scrollableElement = document.querySelector('.db-panel__body');
  }

  private addEventHandlers(): void {
    this.router.events
      .pipe(
        filter((event: any) => event instanceof NavigationEnd),
        takeUntil(this._destroyStream$)
      )
      .subscribe((event: NavigationEnd) => {
        this.routeData = this._routeDataService.getCurrentRouteData();
      });
    this._route.params
      .pipe(
        takeUntil(this._destroyStream$)
      )
      .subscribe(params => {
      this.workspaceTab = this._route.snapshot.params['tabId'];
    });
    this._store.select(fromStore.getWebsitesLoaded)
      .pipe(
        filter((websitesLoaded: boolean) => websitesLoaded),
        switchMap(() => this._store.select(fromStore.getHostedWebsites)),
        filter((hostedWebsites: Website[]): boolean => !!hostedWebsites.length),
        takeUntil(this._destroyStream$)
      )
      .subscribe((hostedWebsites: Website[]) => {
        this.websiteCopied = true;
      });

    this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => combineLatest(
          this._store.select(fromStore.getUserSubscription),
          this._store.select(fromStore.getUserAvailableSubscription(Config.availableSubscriptionId, true)),
           this._store.select(fromStore.getUserAvailableHostingSubscriptions('platform')),
        )),
        takeUntil(this._destroyStream$)
      )
      .subscribe(([currentSubscription, availableSubscription, availableSubscriptions]) => {
        this.currentSubscription = currentSubscription;

        if (this.currentSubscription && this.currentSubscription.platformPaidClient) {
          const annualPrice = availableSubscriptions.find(userSubscription =>
              userSubscription && userSubscription.plan && userSubscription.id === Number(this.currentSubscription.coupleId) && userSubscription.category === this.currentSubscription.category &&
              userSubscription.plan.periodNumber === 12
          );
          this.annualPrice = annualPrice && annualPrice.plan && annualPrice.plan.planPrice;
        }

        this.aiStarterAnnual = availableSubscription;
      });

      this._store.select(fromStore.getWorkspaceIdEntities)
        .pipe(
          filter(workspaceIdEntities => !!workspaceIdEntities.currentWorkspaceRoleId),
          takeUntil(this._destroyStream$)
        )
        .subscribe(workspaceIdEntities => {
          this.currentWorkspaceRole = workspaceIdEntities.currentWorkspaceRoleId;
        });
  }

  ngOnDestroy(): void {
    this._destroyStream$.next(true);
    this._destroyStream$.complete();
  }
  public accountsTabChange($event): void {
    this.workspaceTab = $event.tabId;
    this.router.navigate(['../' + $event.tabId], {relativeTo: this._route, skipLocationChange: false, replaceUrl: true});
  }

  public onMobileScroll(): void {
    if (!this.isMobile || !this.scrollableElement) {
      return;
    }

    this.offsetElement = (<HTMLElement>document.getElementsByTagName("db-" + this.workspaceTab)[0]);

    if (this.scrollableElement.scrollTop > 10) {
      this.offsetElement.classList.add("isScrolled");
    } else {
      this.offsetElement.classList.remove("isScrolled");
    }
    if (this.scrollableElement.scrollTop > 40) {
      this.offsetElement.classList.add("isScrolledMobile");
    } else {
      this.offsetElement.classList.remove("isScrolledMobile");
    }
  }

}
